export default "__VITE_ASSET__C7x59_Tu__"